const HashedId = require('./getHashedId');

// returns true if cache is updated
const addHashedIdToProperties = async (idType, payload, suppressCallback) => {
    const { cacheUpdated, hashedId } = await HashedId.getHashedIdAndUpdateCache(idType, payload, suppressCallback);

    if (hashedId) {
        payload.obj.properties = payload.obj.properties || {};
        payload.obj.properties[idType + 'Hashed'] = hashedId;

        return cacheUpdated;
    }
    return false;
};

// returns true if cache is updated
const addHashedIdToContext = async (idType, payload, suppressCallback) => {
    const { cacheUpdated, hashedId } = await HashedId.getHashedIdAndUpdateCache(idType, payload, suppressCallback);

    if (hashedId) {
        payload.obj.context = payload.obj.context || {};
        payload.obj.context.hashedIds = payload.obj.context.hashedIds || {};
        payload.obj.context.hashedIds[idType + 'Hashed'] = hashedId;

        return cacheUpdated;
    }
    return false;
};

const hashIdsBase = async (payload, next, addHashedId) => {
    if (!payload || !payload.obj) {
        next(payload);
        return;
    }

    try {
        // SHA-256 is now async (native crypto.subtle.digest). Segment's
        // source-middleware contract awaits the middleware function before
        // emitting the event, so awaiting here is safe and only adds a
        // microtask hop per call (the cache short-circuits repeat IDs).
        const hasSetUserId = await addHashedId('userId', payload);
        await addHashedId('anonymousId', payload, hasSetUserId);
    } catch (e) {
        console.log(e);
    } finally {
        next(payload);
    }
};

const hashIdsInProperties = ({ payload, next }) => {
    return hashIdsBase(payload, next, (idType, payload, suppressCallback) =>
        addHashedIdToProperties(idType, payload, suppressCallback)
    );
};

const hashIdsInContext = ({ payload, next }) => {
    return hashIdsBase(payload, next, (idType, payload, suppressCallback) =>
        addHashedIdToContext(idType, payload, suppressCallback)
    );
};

module.exports = {
    hashIdsInProperties,
    hashIdsInContext
};
